module.exports = __webpack_public_path__ + "assets/img/Aussie-Broadband-eBook-w720.39ead1d6.jpg";